import React, { useState } from "react";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import Modal from "../../components/modal/Modal";
import "./register.scss";
import axios from "axios";

const Register = () => {
  const [showModal, setShowModal] = useState(false);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    emailAddress: "",
    password: "",
  });
  const apiUrl = process.env.REACT_APP_REGISTER_API_URL;

  const [fieldErrors, setFieldErrors] = useState({
    lastName: "",
    firstName: "",
    emailAddress: "",
    password: "",
  });

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    if (name === "confirmPassword") {
      setConfirmPassword(value);
    } else {
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value,
      });
      setFieldErrors({
        ...fieldErrors,
        [name]: "",
      });
    }
  };

  const handleCheckboxChange = (event) => {
    setIsTermsChecked(event.target.checked);
  };

  const isFormValid = () => {
    return (
      formData.lastName &&
      formData.firstName &&
      formData.emailAddress &&
      formData.password &&
      formData.password === confirmPassword &&
      isTermsChecked
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const apiEndpoint = "/api/v1/users";
    const apimSubscriptionKey = process.env.REACT_APP_APIM_SUBSCRIPTION_KEY;

    try {
      const response = await axios.post(apiUrl + apiEndpoint, formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key": apimSubscriptionKey,
        },
      });
      setShowModal(true);

      window.location.href = process.env.REACT_APP_APIM_SIGN_IN_URI;
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data && error.response.data.errors) {
        let errors = error.response.data.errors;
        let updatedFieldErrors = { ...fieldErrors };

        errors.forEach((errorItem) => {
          if (errorItem.key && errorItem.value && errorItem.value.length > 0) {
            updatedFieldErrors[errorItem.key] = errorItem.value[0].description;
          }
        });

        setFieldErrors(updatedFieldErrors);
      } else {
        console.error(error.response || error.message);
      }
    }
  };

  return (
    <div>
      <Navbar />
      <div className="registration-page">
        <div className="registration-form">
          <h2>Registration Form</h2>
          <form onSubmit={handleSubmit}>
            <label htmlFor="name">
              Name <span className="required-star">*</span>
            </label>
            <input
              type="text"
              id="name"
              name="lastName"
              required
              onChange={handleInputChange}
            />
            {fieldErrors.lastName && (
              <span className="error-message">{fieldErrors.lastName}</span>
            )}

            <label htmlFor="firstName">
              First Name <span className="required-star">*</span>
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              required
              onChange={handleInputChange}
            />
            {fieldErrors.firstName && (
              <span className="error-message">{fieldErrors.firstName}</span>
            )}

            <label htmlFor="email">
              Email <span className="required-star">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="emailAddress"
              required
              onChange={handleInputChange}
            />
            {fieldErrors.emailAddress && (
              <span className="error-message">{fieldErrors.emailAddress}</span>
            )}

            <label htmlFor="password">
              Password <span className="required-star">*</span>
            </label>
            <input
              type="password"
              id="password"
              name="password"
              required
              onChange={handleInputChange}
            />
            {fieldErrors.password && (
              <span className="error-message">{fieldErrors.password}</span>
            )}

            <label htmlFor="confirmPassword">
              Confirm Password <span className="required-star">*</span>
            </label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              required
              onChange={handleInputChange}
            />
            {formData.password !== confirmPassword && (
              <span className="error-message">Passwords must match</span>
            )}

            <div className="checkbox-group">
              <input
                type="checkbox"
                id="terms"
                name="terms"
                onChange={handleCheckboxChange}
              />
              <label htmlFor="terms">
                I agree to the{" "}
                <a
                  href="https://www.duco.eu/uk-ie/duco-home-control-privacy-statement"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  DUCO terms and conditions
                </a>
              </label>
            </div>

            <button
              type="submit"
              className={isFormValid() ? "active-button" : "disabled-button"}
            >
              Register
            </button>
          </form>
        </div>
        <Modal show={showModal}>
          <p>Registration successful, redirecting to login page...</p>
        </Modal>
      </div>
      <Footer />
    </div>
  );
};

export default Register;
